import GlobalTitle from '~/components/atoms/Editorial/Global/GlobalTitle.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import '@web/shared-digital-library/icons/svg-originals/chevron-right.svg';
export default {
  name: 'LinkBlock',
  components: {
    GlobalTitle,
    SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      return {
        blocks: this.payload.items.map(i => {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6;
          return {
            image: {
              small: formatPrismicImage((_ref6 = i) != null ? (_ref6 = _ref6.image) != null ? _ref6.url : _ref6 : _ref6, ['w_75,dpr_2']) || EMPTY_PIXEL
            },
            alt: ((_ref5 = i) != null ? _ref5.alt : _ref5) || null,
            title: ((_ref4 = i) != null ? (_ref4 = _ref4.title) != null ? _ref4[0] : _ref4 : _ref4) || {},
            paragraph: ((_ref3 = i) != null ? _ref3.paragraph : _ref3) || '',
            url: ((_ref2 = i) != null ? (_ref2 = _ref2.url) != null ? _ref2.url : _ref2 : _ref2) || '',
            target: (_ref = i) != null ? (_ref = _ref.url) != null ? _ref.target : _ref : _ref
          };
        })
      };
    },
    elements() {
      return this.currentPayload.blocks.slice(0, 4);
    }
  }
};